import { motion } from "framer-motion";
import { Quote } from "lucide-react";
import { TESTIMONIALS } from "@/lib/constants";
import { SectionHeader } from "@/components/Services";

export const Testimonials = () => {
  return (
    <section id="testimonials" data-testid="testimonials-section" className="py-24 relative">
      <div className="section-divider mb-24 max-w-7xl mx-auto" />
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <SectionHeader
          eyebrow="Client Voices"
          title="Words from Indian business owners we've partnered with."
          desc="Real, unfiltered feedback from businesses we serve. Identifying details are shared with client permission only."
          center
        />
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5 lg:gap-6">
          {TESTIMONIALS.map((t, i) => (
            <motion.div
              key={i}
              initial={{ opacity: 0, y: 18 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: i * 0.08, duration: 0.55 }}
              data-testid={`testimonial-card-${i}`}
              className="relative rounded-2xl p-7 glass glass-hover"
            >
              <Quote size={22} className="text-[#D4AF37]/70 mb-4" />
              <p className="text-white/85 leading-relaxed text-[15px]">"{t.quote}"</p>
              <div className="mt-6 flex items-center gap-3 pt-4 border-t border-white/5">
                <div className="w-10 h-10 rounded-full grid place-items-center bg-[#D4AF37]/15 border border-[#D4AF37]/40 text-[#D4AF37] font-semibold">
                  {t.initials}
                </div>
                <div>
                  <div className="text-white text-sm font-semibold">{t.name}</div>
                  <div className="text-xs text-white/55">{t.role}</div>
                </div>
              </div>
            </motion.div>
          ))}
        </div>
        <div className="mt-10 text-center text-xs text-white/40">
          Client names are shared with consent. VR Marketing Hub never fabricates reviews or ratings.
        </div>
      </div>
    </section>
  );
};
